export type StatusBadgeType = "approved" | "pending" | "rejected" | "";

export const getStatusClass = (status: string): StatusBadgeType => {
  switch (status) {
    case "UPLOADING":
    case "UPLOADED":
    case "APPROVED":
    case "WAITING_FOR_APPROVAL":
    case "REQUESTING_CREATE_INTERACTION":
    case "EXTRACT_FAILED":
      return "pending";
    case "REJECTED":
    case "UPLOAD_FAILED":
      return "rejected";
    case "COMPLETED":
      return "approved";
    default:
      return "";
  }
};

export const getStatusDisplayText = (status: string): string => {
  switch (status) {
    case "UPLOADING":
    case "UPLOADED":
      return "Neu";
    case "UPLOAD_FAILED":
    case "REJECTED":
      return "Abgelehnt";
    case "WAITING_FOR_APPROVAL":
    case "EXTRACT_FAILED":
      return "Wartet auf Genehmigung";
    case "APPROVED":
    case "REQUESTING_CREATE_INTERACTION":
      return "Akzeptiert";
    case "COMPLETED":
      return "Abgeschlossen";
    default:
      return status;
  }
};
